export default [
    {
        path: '/keys',
        name: 'keys',
        component: () => import('../../pages/keys/IndexPage.vue'),
        meta: {
            title: 'Signing Keys',
            requiresAuth: true,
        },
    },
]
